import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

const initialState = "";

export const snackBarMessageSlice = createSlice({
  name: "snackBarMessage",
  initialState,
  reducers: {
    setSnackBarMessage: (state, action: PayloadAction<string>) => {
      state = action.payload;
      return state;
    },
  },
});

export const { setSnackBarMessage } = snackBarMessageSlice.actions;

export default snackBarMessageSlice.reducer;
